export enum QueryKeyEnum {
  CAMERA = 'camera',
  CAMERAS = 'cameras',
  CLIENT = 'client',
  CLIENTS = 'clients',
  CREATE_FACE = 'create_face',
  UPDATE_FACE = 'update_face',
  LINE_CROSSING = 'line_crossing',
  SNAPSHOT = 'snapshot',
  OBJECTS = 'objects',
  OBJECTS_TYPES = 'objects_types',
  SCHEDULE_BY_CAMERA = 'schedule_by_camera',
  BRAIN_BOXES = 'brain_boxes',
  OUTPUT_SERVER = 'output_server',
  INTEREST_AREA = 'interest_area',
  START_STREAM = 'start_stream',
  FACES = 'faces',
  FACE_LISTS = 'face_lists',
  LICENSE_PLATE = 'license_plate',
  FACE_DETECTIONS = 'face_detections',
  FACE_DETECTIONS_WS = 'face_detections_ws',
  DASHBOARD_CAMERAS = 'dashboard_cameras',
  DASHBOARD_EVENTS_COUNT_BY_CAMERA = 'dashboard_events_count_by_camera',
  DASHBOARD_FACIAL_RECOGNITION = 'dashboard_facial_recognition',
  DASHBOARD_LPR = 'dashboard_lpr',
  DASHBOARD_EVENTS_BY_STATUS = 'dashboard_events_by_status',
  DASHBOARD_EVENTS_BY_HOUR = 'dashboard_events_by_hour',
  DASHBOARD_OBJECTS_COUNT = 'dashboard_objects_count',
  DASHBOARD_AGE_AND_GENDER = 'dashboard_age_and_gender',
  DASHBOARD_GENDER_SERIES = 'dashboard_gender_series',
  DASHBOARD_OBJECT_SERIES = 'dashboard_object_series',
  DASHBOARD_FACE_SERIES = 'dashboard_face_series',
  DASHBOARD_COUNTING_OBJECTS_SERIES = 'dashboard_counting_objects_series',
  EVENTS = 'events',
  DASHBOARD_HEATMAP = 'dashboard_heatmap',
  DASHBOARD_COUNTING_OBJECTS = 'dashboard_counting_objects',
  CAMERA_HISTORY = 'camera_history',
  CAMERA_WARNINGS = 'camera_warnings',
  DASHBOARD_PERSONALIZED_AGE_GENDER_COUNTING = 'dashboard_personalized_age_gender_counting',
  DASHBOARD_PERSONALIZED_COUNTING_FACES = 'dashboard_personalized_counting_faces',
  DASHBOARD_PERSONALIZED_HEATMAP_FACES = 'dashboard_personalized_heatmap_faces',
  DASHBOARD_PERSONALIZED_COUNTING_WITH_AVERAGE = 'dashboard_personalized_counting_with_average',
  DASHBOARD_PERSONALIZED_SYNTHETIC_DATA = 'dashboard_personalized_synthetic_data',
  COMPANIES = 'companies',
  CREATE_CLIENT = 'create_client',
  LAYOUTS = 'layouts',
  EDGE_SERVERS = 'edge_servers',
  DASHBOARD_PERMANENCY_AVG = 'dashboard_permanency_avg',
  RETENTION_RANGES = 'retention_ranges',
}
